import Vue from 'vue'
import Vuex from 'vuex'
//BOC
import account from "./modules/account";
import technician from "./modules/technician";
//EOC

Vue.use(Vuex)
const debug = process.env.VUE_APP_ENV !== 'production'

//BOC:[persist]
import VuexPersistence from 'vuex-persist'
import Cookies from 'js-cookie'
const vuexCookie = new VuexPersistence({
	key:"cookieStore",
	restoreState: (key) => Cookies.get(key),
	saveState: (key, state) =>
		Cookies.set(key, state, {
			expires: 30, // expire in 30 days
		}),
	modules:[
		//
	],
});
const vuexLocal = new VuexPersistence({
	key:"localStore",
	storage: window.localStorage,
	modules:[
    "account",
	"technician",
	],
})
//EOC

export default new Vuex.Store({
	modules: {
    account:account,
	technician:technician,
	},
	strict: debug,
	plugins: [
		vuexCookie.plugin, 
		vuexLocal.plugin,
	],
})
